import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import validation from '@/translations/validation';
import store from '@/store';
Validator.localize(validation);

const uniqueRef = (staffRef, checkingStaff) => {
  const subLocations = store.state.toggle.staffSubLocations;
  if(subLocations.length == 0) {
    return {
      valid: false,
      data: {
        message: Vue.prototype.$gettext('Choose location first')
      }
    };
  }
  const staffs = store.getters.getArray('staffs');
  const refs = {};
  staffs.forEach(staff => {
    if(!staff.subLocations 
        || staff.subLocations.length == 0
        || (checkingStaff.id && staff.id == checkingStaff.id)
      ) return;
    const intersection =  staff.subLocations
                            .filter(location => subLocations.includes(location));
    if(intersection.length > 0) {
      refs[staff.ref] = true;
    }
  });
  if(!Object.keys(refs).includes(staffRef)) return {valid: true};
  return {
    valid: false,
    data: {
      message: Vue.prototype.$gettext('Staff Id used in location')
    }
  };
};

Validator.extend('uniqueRef', {
  validate: uniqueRef,
  getMessage: (field, params, { message }) => message,
});

Vue.use(VeeValidate, { fieldsBagName: 'formFields' });

export default VeeValidate;
